export class AppError extends Error {
  /**
   * @param {string} message
   * @param {string|number} code
   * @param {object} [extra]
   */
  constructor(message, code, extra = {}) {
    super(message);
    this.name = "AppError";
    this.code = code;
    this.message = message;
    this.extra = extra;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, AppError);
    }
  }
}

export class UnauthorizedError extends Error {
    /**
     * @param {string} message
     * @param {object} [extra]
     */
    constructor(message, extra = {}) {
      super(message);
      this.name = "UnauthorizedError";
      this.message = message;
      this.extra = extra;
  
      if (Error.captureStackTrace) {
        Error.captureStackTrace(this, UnauthorizedError);
      }
    }
  }
